import { useState } from "react";
import InputB from "../InputB/InputB"
import ColorPicker from 'react-pick-color';

export default function ColorPickerDropDown(props: {
  currentColor: string,
  changeColor: (c: string) => void,
  side?: 'left' | 'right',
}) {
  const [currentColor, setCurrentColor] = useState(props.currentColor || '#000')
  function useColor(c: string) {
    setCurrentColor(c)
    props.changeColor(c)
  }
  const style = props.side === 'left' ? {left: 0} : {right: 0}
  return  <div className="w3-dropdown-hover">
  <button className="w3-button">
    <div className={`colorBox w3-border`} style={{
      backgroundColor: currentColor,
      height: '24px',
      width: '24px',
      }}></div>
  </button>
  <div className="w3-dropdown-content w3-bar-block w3-border" style={style}>
    <LocalColorPicker
      currentColor={props.currentColor}
      changeColor={useColor}
    />
    
  </div>
</div> 
}

function LocalColorPicker(props: {
  currentColor: string,
  changeColor: (c: string) => void,
}) {
  const [currentColor, setCurrentColor] = useState(props.currentColor || '#000')
  const [theTimeout, setTheTimeout] = useState(0)
  const TIMEOUTVAL = 500
  return <div className='colorPicker'>
    <InputB
      value={currentColor}
      returnVal={(color) => {
        setCurrentColor(color)
        props.changeColor(color)
      }}
      delay={TIMEOUTVAL}
    />
    <ColorPicker
      color={currentColor}
      onChange={color => {
        setCurrentColor(color.hex)
        clearTimeout(theTimeout)
        setTheTimeout(window.setTimeout(() => {
          props.changeColor(color.hex)
        }, TIMEOUTVAL))
      }}
    />
  </div>
}
